import axios from "axios";
import { tmsApi } from "../api";

export const getScheduledTrips = async (body) => {
  const config = {
    headers: {
      token: `${localStorage.getItem('token')}`,
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios.post(tmsApi + "v1/services/dispatcherdashboard/count/aggregrates",body, config).then((resp) => {
      console.log(resp, "response");
      return resp;
    });
  } catch (error) {
    console.log("error", error);
    return error
  }
};

export const getBookingAcceptedData = async () => {
  const config = {
    headers: {
      token: `${localStorage.getItem('token')}`,
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios.get(tmsApi + "v1/services/dispatcherdashboard/accepted/bookings", config).then((resp) => {
      console.log(resp, "response");
      return resp;
    });
  } catch (error) {
    console.log("error", error);
    return error
  }
};


export const getAggregators = async () => {
  const config = {
    headers: {
      token: `${localStorage.getItem('token')}`,
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios.get(tmsApi + "v1/entities/aggregator", config).then((resp) => {
      console.log(resp, "response");
      return resp;
    });
  } catch (error) {
    console.log("error", error);
    return error
  }
};

export const getCancelledTrips = async (body) => {
  const config = {
    headers: {
      token: `${localStorage.getItem('token')}`,
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios.post(tmsApi + "v1/entities/trip/cancelled",body, config).then((resp) => {
      console.log(resp, "response");
      return resp;
    });
  } catch (error) {
    console.log("error", error);
    return error
  }
};

export const getScheduledTripsTable = async (body) => {
  const config = {
    headers: {
      token: `${localStorage.getItem('token')}`,
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios.post(tmsApi + "v1/services/dispatcherdashboard/scheduled/trips",body, config).then((resp) => {
      console.log(resp, "response");
      return resp;
    });
  } catch (error) {
    console.log("error", error);
    return error
  }
};

export const getOnlineCabs = async () => {
  const config = {
    headers: {
      token: `${localStorage.getItem('token')}`,
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios.get(tmsApi + "v1/services/dispatcherdashboard/online/cabs/graph", config).then((resp) => {
      console.log(resp, "response");
      return resp;
    });
  } catch (error) {
    console.log("error", error);
    return error
  }
};



export const getDashboardCount = async (body) => {
  const config = {
    headers: {
      token: `${localStorage.getItem('token')}`,
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios.post(tmsApi + "v1/services/dispatcherdashboard/cards/count",body,config).then((resp) => {
      console.log(resp, "response");
      return resp;
    });
  } catch (error) {
    console.log("error", error);
    return error
  }
};


export const createDriverAdhoc = async (body) => {
  const config = {
    headers: {
      token: `${localStorage.getItem('token')}`,
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios.post(tmsApi + "v1/entities/driver", body,config).then((resp) => {
      console.log(resp, "response");
      return resp;
    });
  } catch (error) {
    console.log("error", error);
    return error
  }
};

export const updateDriverAdhoc = async (body) => {
  const config = {
    headers: {
      token: `${localStorage.getItem('token')}`,
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios.put(tmsApi + "v1/entities/driver", body,config).then((resp) => {
      console.log(resp, "response");
      return resp;
    });
  } catch (error) {
    console.log("error", error);
    return error
  }
};

export const checkRoleAddition = async (body) => {
  const config = {
    headers: {
      token: `${localStorage.getItem('token')}`,
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios.post(tmsApi + "checkForRoleAddition", body,config).then((resp) => {
      console.log(resp, "response");
      return resp;
    });
  } catch (error) {
    console.log("error", error);
    return error
  }
};

export const driverDocumentUpload = async (body) => {
  const config = {
    headers: {
      token: `${localStorage.getItem('token')}`,
      "Access-Control-Allow-Origin": "*",
      'Content-Type': 'multipart/form-data'
    },
  };
  try {
    return axios.post(tmsApi + "v1/entities/driver/documents/upload", body,config).then((resp) => {
      console.log(resp, "response");
      return resp;
    });
  } catch (error) {
    console.log("error", error);
    return error
  }
};

export const getDriverDocuments = async (id) => {
  const config = {
    headers: {
      token: `${localStorage.getItem('token')}`,
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios.get(tmsApi + `v1/entities/driver/documents/listing?driverId=${id}`,config).then((resp) => {
      console.log(resp, "response");
      return resp;
    });
  } catch (error) {
    console.log("error", error);
    return error
  }
};

export const uploadDriverImage = async (body) => {
  const config = {
    headers: {
      token: `${localStorage.getItem('token')}`,
      "Access-Control-Allow-Origin": "*",
      'Content-Type': 'multipart/form-data'
    },
  };
  try {
    return axios.post(tmsApi + "v1/entities/driver/image/upload", body, config).then((resp) => {
      console.log(resp, "response");
      return resp;
    });
  } catch (error) {
    console.log("error", error);
    return error
  }
};

export const getDriverImage = async (id) => {
  const config = {
    headers: {
      token: `${localStorage.getItem('token')}`,
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios.get(tmsApi + `v1/entities/driver/image?driverId=${id}`, config).then((resp) => {
      console.log(resp, "response");
      return resp;
    });
  } catch (error) {
    console.log("error", error);
    return error
  }
};


export const getUnAssignedTrips = async (body) => {
  const config = {
    headers: {
      token: `${localStorage.getItem('token')}`,
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios.post(tmsApi + "v1/entities/booking/unassigned", body,config).then((resp) => {
      console.log(resp, "response");
      return resp;
    });
  } catch (error) {
    console.log("error", error);
    return error
  }
};

export const getOnTripDetails = async (obj) => {
  const config = {
    headers: {
      token: `${localStorage.getItem('token')}`,
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios.get(tmsApi + `v1/entities/ontrip/list/servicecity/${obj.serviceCityId}`,config).then((resp) => {
      console.log(resp, "response");
      return resp;
    });
  } catch (error) {
    console.log("error", error);
    return error
  }
};









